import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FAQ_DATA = [
  {
    q: "Ile trwa manicure hybrydowy?",
    a: "Rzetelnie wykonany manicure hybrydowy w BEAUTIX zajmuje 60–90 minut. Nie skracamy tego etapu — dokładne opracowanie skórek e-frezarką i pełne przygotowanie płytki to podstawa trwałości hybrydy.",
  },
  {
    q: "Czy stosujecie autoklaw i pełną sterylizację?",
    a: "Tak. Narzędzia sterylizujemy w autoklawie klasy B po każdej klientce. W podologii dodatkowo używamy jednorazowych frezów oraz jednorazowych zestawów sterylnych. Higiena to nasz priorytet.",
  },
  {
    q: "Czy trzeba się umawiać wcześniej?",
    a: "Tak, wszystkie usługi realizujemy po wcześniejszej rezerwacji telefonicznej. Zadzwoń pod 794 000 270 lub 32 203 58 65 — porozmawiamy o terminie i dobierzemy zabieg do Twoich potrzeb.",
  },
  {
    q: "Jakie formy płatności akceptujecie?",
    a: "Gotówkę, kartę płatniczą oraz BLIK. Wystawiamy również faktury na życzenie.",
  },
  {
    q: "Czy oferujecie karty podarunkowe?",
    a: "Tak! Karty podarunkowe BEAUTIX dostępne są w kwotach 100, 200, 300 i 500 zł (lub kwoty indywidualnej). Świetny pomysł na prezent na święta, urodziny czy Dzień Matki. Zadzwoń, żeby zamówić.",
  },
  {
    q: "Czy jest parking blisko salonu?",
    a: "Tak, przy ul. Ligockiej 80 znajduje się bezpłatny parking. Salon jest łatwo dostępny również komunikacją miejską.",
  },
  {
    q: "Jak przygotować się do mezoterapii mikroigłowej?",
    a: "Na tydzień przed zabiegiem odstaw retinoidy i mocne kwasy, unikaj słońca i solarium. Przyjdź bez makijażu. Nasza kosmetolog przeprowadzi konsultację i dobierze koktajl do stanu skóry.",
  },
  {
    q: "Czy leczycie wrastające paznokcie bez wizyty u chirurga?",
    a: "W większości przypadków tak. Stosujemy bezinwazyjne klamry ortonyksyjne, które delikatnie unoszą płytkę i korygują jej wzrost — bez cięcia, bez rekonwalescencji, bez blizn.",
  },
];

export default function Faq({ items = FAQ_DATA, compact = false }) {
  const [openIdx, setOpenIdx] = useState(0);
  const list = compact ? items.slice(0, 5) : items;

  return (
    <section
      className="py-24 md:py-32 bg-[var(--beautix-cream)] relative overflow-hidden"
      data-testid="faq-section"
      aria-label="Najczęściej zadawane pytania"
    >
      <div className="absolute inset-0 grain" />
      <div className="max-w-5xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start mb-14">
          <div className="lg:col-span-6">
            <p className="eyebrow mb-4">Najczęstsze pytania</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Odpowiedzi{" "}
              <span className="italic text-[var(--beautix-pink)]">na wprost</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-4">
            <p className="text-base text-[var(--beautix-muted)] leading-relaxed">
              Zebraliśmy w jednym miejscu pytania, które najczęściej dostajemy
              telefonicznie. Nie znalazłaś odpowiedzi? Zadzwoń do salonu — chętnie
              porozmawiamy.
            </p>
          </div>
        </div>

        <div className="divide-y divide-[var(--beautix-line)] border-y border-[var(--beautix-line)]">
          {list.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="font-serif-display text-xl md:text-2xl text-[var(--beautix-ink)] group-hover:text-[var(--beautix-pink)] transition-colors">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 shrink-0 text-[var(--beautix-pink)] transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    strokeWidth={1.5}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-base text-[var(--beautix-muted)] leading-relaxed pr-10 font-light">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
